import React, { FC, useState } from 'react'
import {useProducts} from './ProductsProvider'
import {RequestAProduct} from '../modules/functions/post'
import {KTSVG} from '../../_metronic/helpers'

// ===========================
// TYPES
// ===========================

interface RequestAProductButtonProps {
  name: string
  productKey: string
  description: string
  index: number
}

// ===========================
// COMPONENT
// ===========================

export const RequestAProductButton: FC<RequestAProductButtonProps> = ({
  name,
  productKey,
  description,
  index,
}) => {
  const { getTreatyStatus, refetch } = useProducts()
  
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [treaty1, setTreaty1] = useState(false)

  // Obtenir le statut du produit
  const treatyStatus = getTreatyStatus(productKey)
  const hasProductRequest = treatyStatus !== undefined
  const isProcessing = treatyStatus === 0 || treatyStatus === 1

  // ID unique pour le modal
  const productId = `${productKey}_${index}`

  // Gérer la soumission
  const handleSubmit = () => {
    if (!message.trim()) {
      alert('Veuillez entrer un message')
      return
    }

    const values = {
      message: message.trim(),
      products: productKey,
    }

    // Appeler la fonction existante
    RequestAProduct({
      values,
      setStatus,
      setDisable: setIsDisabled,
      setLoading: setIsLoading,
      setTreaty1: (value) => {
        setTreaty1(value)
        // Recharger les produits après succès
        setTimeout(() => {
          refetch()
        }, 1000)
      },
    })
  }

  // Réinitialiser le formulaire quand le modal est fermé
  const handleModalClose = () => {
    if (!isLoading) {
      setMessage('')
      setStatus('')
    }
  }

  // Rendu du bouton ou de l'indicateur de traitement
  const renderButton = () => {
    if (hasProductRequest && isProcessing) {
      return (
        <div className="d-flex justify-content-between align-items-center fs-7 text-info fw-bolder demandIcon">
          <div>Traitement en cours</div>
          <KTSVG
            path="/media/icons/duotune/abstract/abs014.svg"
            className="svg-icon-1 svg-icon-info mx-2"
          />
        </div>
      )
    }

    return (
      <button
        type="button"
        className="btn btn-sm btn-flex btn-light btn-active-light-primary fw-bolder"
        data-bs-toggle="modal"
        data-bs-target={`#kt_modal_${productId}`}
        disabled={treaty1 || isDisabled}
      >
        <KTSVG
          path="/media/icons/duotune/general/gen044.svg"
          className="svg-icon-1 svg-icon-gray-500 me-1"
        />
        {treaty1 ? 'Demande envoyée' : 'Demande de devis'}
      </button>
    )
  }

  return (
    <>
      {/* Bouton ou indicateur */}
      {renderButton()}

      {/* Modal Bootstrap */}
      <div
        className="modal fade"
        id={`kt_modal_${productId}`}
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <h2 className="fw-bolder">{name}</h2>
              <button
                type="button"
                className="btn btn-icon btn-sm btn-active-icon-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleModalClose}
                disabled={isLoading}
              >
                <KTSVG
                  path="/media/icons/duotune/arrows/arr061.svg"
                  className="svg-icon-1"
                />
              </button>
            </div>

            {/* Body */}
            <div className="modal-body scroll-y mx-5 mx-xl-15 my-7">
              {status ? (
                <div className={`alert ${status.includes('erreur') ? 'alert-danger' : 'alert-success'}`}>
                  <div className="d-flex align-items-center">
                    <KTSVG
                      path="/media/icons/duotune/general/gen043.svg"
                      className="svg-icon-2 svg-icon-success me-3"
                    />
                    <div className="flex-grow-1">
                      {status}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {description && (
                    <div className="mb-7">
                      <div className="text-gray-600 fw-bold fs-6">{description}</div>
                    </div>
                  )}

                  <div className="fv-row mb-7">
                    <label className="required fw-bold fs-6 mb-2">Votre message</label>
                    <textarea
                      className="form-control form-control-solid mb-3 mb-lg-0"
                      rows={6}
                      placeholder="Décrivez votre besoin en détail..."
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      disabled={isLoading || isDisabled}
                    />
                  </div>
                </>
              )}
            </div>

            {/* Footer */}
            <div className="modal-footer">
              {!status ? (
                <>
                  <button
                    type="button"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                    onClick={handleModalClose}
                    disabled={isLoading}
                  >
                    Annuler
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={isLoading || isDisabled || !message.trim()}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Envoi en cours...
                      </>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/general/gen016.svg"
                          className="svg-icon-3 me-2"
                        />
                        Envoyer la demande
                      </>
                    )}
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={handleModalClose}
                >
                  Fermer
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RequestAProductButton
